import { jsx } from 'react/jsx-runtime';

const SvgInformation = (props) => /* @__PURE__ */ jsx("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5a8.5 8.5 0 1 1 17.001.001A8.5 8.5 0 0 1 0 8.5Zm1 0C1 12.635 4.365 16 8.5 16S16 12.635 16 8.5 12.635 1 8.5 1 1 4.365 1 8.5ZM8.5 6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5ZM8 3.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Z",
    fill: "#445058"
  })
});

export { SvgInformation as default };
//# sourceMappingURL=Information.js.map
